module.exports = __webpack_public_path__ + "img/cabins-map--es.3023036b.png";